import React from 'react'
import { t } from '@lingui/core/macro'
import MerchantSiteRedirectButton from '../MerchantSiteRedirectButton/MerchantSiteRedirectButton'
import styles from './Expired.module.css'

interface ExpiredProps {
    orderId?: string
    redirectUrl?: string
    redirectTimeout?: number
}

const Expired = ({ orderId, redirectUrl, redirectTimeout }: ExpiredProps) => {
    return (
        <>
            <div className={styles.expiredMessage}>
                <div className={styles.icon}>⏰</div>
                <h2 className={styles.title}>{t`Время оплаты истекло`}</h2>
                <p className={styles.text}>
                    {orderId
                        ? t`К сожалению, время для оплаты заказа ${orderId} истекло.`
                        : t`К сожалению, время для оплаты истекло.`
                    }
                </p>
                <br/>
                <p className={styles.expired}>
                    {t`Пожалуйста, свяжитесь с продавцом для создания новой ссылки на оплату.`}
                </p>
            </div>
            <MerchantSiteRedirectButton redirectUrl={redirectUrl}  redirectTimeout={redirectTimeout} />
        </>
    )
}

export default Expired
